import i18n from "i18next";
import { initReactI18next } from "react-i18next";


// Importing translation files

import translationEN from "./locales/en/translation.json";
import translationRS from "./locales/rs/translation.json";
import translationSP from "./locales/es/translation.json";
import translationDE from "./locales/de/translation.json";
import translationFR from "./locales/fr/translation.json";
import translationPT from "./locales/pt/translation.json";
import translationIT from "./locales/it/translation.json";
import translationPL from "./locales/pl/translation.json";
import translationTR from "./locales/tr/translation.json";



//Creating object with the variables of imported translation files
const resources = {
  en: {
    translation: translationEN,
  },
  sr: {
    translation: translationRS,
  },
  es: {
    translation: translationSP,
  },
  de: {
    translation: translationDE,
  },
  fr: {
    translation: translationFR
  },
  pt: {
    translation: translationPT
  },
  it: {
    translation: translationIT
  },
  pl: {
    translation: translationPL
  },
  tr: {
    translation: translationTR
  }
};

//i18N Initialization

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng:"en", //default language
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;